/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsAllReviewIssueNewRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.all.review.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsAllReviewIssueNewRoute);
